export class MP3Data {
    object_type: number;
    sample_rate: number;
    channel_count: number;

    data: Uint8Array;
}
